(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sereg-featured-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.fpReady) return;
      root.dataset.fpReady = '1';
      var track = root.querySelector('[data-fp-track]');
      if (!track) return;
      var thumbs = root.querySelectorAll('[data-fp-thumb]');
      var dots = root.querySelectorAll('.sereg-fp__dot');
      function setActive(i) {
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', i === j); });
        dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = parseInt(t.dataset.fpThumb, 10) || 0;
          track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
          setActive(i);
        });
      });
      var timer;
      track.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          setActive(Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)));
        }, 60);
      }, { passive: true });
    }
    function run() { document.querySelectorAll('.sereg-fp').forEach(init); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();
})();
